import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Badge } from '../../components/ui/badge';
import { Loader2, Table as TableIcon, ChevronLeft } from 'lucide-react';

export function AccessTableViewer({ selectedTable, tableData, loadingTable, onClose }) {
  return (
    <Card className="border-2 border-primary/20">
      <CardHeader className="pb-3">
        <div className="flex justify-between items-center">
          <CardTitle className="font-heading flex items-center gap-2">
            <TableIcon className="w-5 h-5 text-primary" />
            Tabla: {selectedTable}
            {tableData && (
              <Badge variant="outline" className="ml-2">
                {tableData.showing} de {tableData.total_rows} filas
              </Badge>
            )}
          </CardTitle>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            data-testid="close-table-btn"
          >
            <ChevronLeft className="w-4 h-4 mr-1" />
            Volver a tablas
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {loadingTable ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="w-8 h-8 animate-spin text-primary" />
            <span className="ml-3 text-muted-foreground">Cargando datos...</span>
          </div>
        ) : tableData ? (
          <div className="overflow-x-auto max-h-[500px] overflow-y-auto border rounded-md">
            <Table>
              <TableHeader className="sticky top-0 bg-background">
                <TableRow>
                  {tableData.columns.map((col, idx) => (
                    <TableHead key={`col-${col}-${idx}`} className="font-heading whitespace-nowrap">
                      {col}
                    </TableHead>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody>
                {tableData.rows.map((row, rowIdx) => (
                  <TableRow key={`row-${rowIdx}`}>
                    {tableData.columns.map((col, colIdx) => (
                      <TableCell key={`cell-${rowIdx}-${colIdx}`} className="whitespace-nowrap text-sm">
                        {row[col] || '-'}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        ) : (
          <p className="text-center text-muted-foreground py-8">
            No se pudieron cargar los datos
          </p>
        )}
      </CardContent>
    </Card>
  );
}
